import { Injectable } from '@angular/core';
import { StorageService } from '../providers/storage.service';

@Injectable()
export class BettingParamService {
    public static year: number;
    public static creditOnlyLotteryCodes = ["50001", "95000"];

    public static isCreditOnlyLottery(lotteryCode: string) {
        return this.creditOnlyLotteryCodes.indexOf(lotteryCode) > -1;
    }

    public static applyPlayModeBeforeNavigate(lotteryCode: string, storage: StorageService) {
        storage.writeString("playModeType", this.isCreditOnlyLottery(lotteryCode) ? "1" : "0");
    }

    public setParam(param: number) {
        BettingParamService.year = param;
    }
    public getParam() {
        return BettingParamService.year;
    }
}


// WEBPACK FOOTER //
// ./src/services/betting.param.service.ts